// extracted by mini-css-extract-plugin
module.exports = {"theComp":"FreedomB_theComp__FaPu6"};